import { Observable } from 'rxjs';

import { Tab } from './experimental.tabset';

export enum TabType {
    ADD,
    HUMAN,
    PERFORMANCE,
}

export interface TabContext<T> {
    type: TabType;
    originalLabel: string;
    label: string;
    predefined?: boolean;
    config: T;
    isDefault?: boolean;
    isFavourite?: boolean;
}

export interface ConfigureTab<T> {
    setDefault: Observable<boolean>;
    setFavourite: Observable<boolean>;
    addNewTab: Observable<Tab<TabContext<T>>>;
}

export interface ConfigureTabReceiver<T> {
    onSetDefaultTab: ($event: boolean) => void;
    onSetFavouriteTab: ($event: boolean) => void;
    onAddNewTab: ($event: Tab<TabContext<T>>) => void;
}
